<template>
  <div class="pod-no-preview-wrapper">
    <div v-if="getImage" v-bind:style="getCSS">
    </div>
  </div>
</template>

<script>
import noTranscodedVideo from "../../../assets/images/no-transcoded-video.png"
import noTranscodedAudio from "../../../assets/images/no-transcoded-audio.png"
import noTranscodedImage from "../../../assets/images/no-transcoded-image.png"

export default {
  name: "NoPreviewAvailable",
  props: {
    assetType: {
      type: String,
      required: false,
    }
  },
  computed: {
    getImage: function() {
      if (this.assetType == 'image') return noTranscodedImage;
      if (this.assetType == 'audio') return noTranscodedAudio;

      return noTranscodedVideo;
    },
    getCSS: function() {
      return {
        width: '100%',
        backgroundImage: 'url("' + this.getImage + '")',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        paddingTop: '45%',   // 20:9
      };
    },
  }
}
</script>

<style>
.pod-no-preview-wrapper {
  width: 100%;
  padding: 20px;
  border-radius: 10px;

  background-color: rgb(var(--v-theme-tw-surface));
}

/* .v-theme--light .pod-no-preview-wrapper {
  background-color: #FFFFFF;
}

.v-theme--dark .pod-no-preview-wrapper {
  background-color: #232b36;
} */
</style>
